import { ConcessionariaModel } from './../../app/models/ConcessionariaModel';
import { Injectable } from '@angular/core';
import { ConfigHelper } from '../../app/helpers/configHelper';
import { Storage } from '@ionic/storage';
import { HttpProvider } from '../http/http';
import { imagensConcessionaria } from './../../app/models/ImagensModel';
import { Platform } from 'ionic-angular';

@Injectable()
export class ConfiguracaoConcessionariaProvider {

  imagensConcessionaria:imagensConcessionaria;
  concessionaria: ConcessionariaModel = new ConcessionariaModel();
  iniciado:boolean = false;
  constructor(public storage: Storage,
    private httpSrv: HttpProvider,
    public platform: Platform
  ) 
  {
  }

  public isTablet(){
    let width = window.innerWidth;
    let height = window.innerHeight;
  
    let isAndroid = this.platform && this.platform.platforms().includes('android')
    let tamanhoDaTela = Math.min(width, height) >= 720;

    return isAndroid && tamanhoDaTela;
  }


  public async isBeta(){
    let valor = this.isConcessionaria();
    valor.then(async (val) => {
      if (val){
        this.concessionaria = JSON.parse(val);
      }
    });
   return this.concessionaria.appBeta;
  }

  public async isLogado(){
    return await this.storage.get(ConfigHelper.storageKeys.codConcessionaria);
  }

  public async isConcessionaria(){
    return await this.storage.get(ConfigHelper.storageKeys.concessionaria);
  }

  public async isCameraAberta(){
    return await this.storage.get(ConfigHelper.storageKeys.cameraAberta);
  }

  public async getUltimaDataLimpaCache(){
    return await this.storage.get(ConfigHelper.storageKeys.ultimaDataLimpaCache);
  }

  public async iniciaImagens(){
    let valor = this.isConcessionaria();
    valor.then(async (val) => {
      if (val){
        this.concessionaria = JSON.parse(val);
      }
    });
    var imagensConcessionariaArray = new Array<imagensConcessionaria>();
    let textImagensCardapio = await this.storage.get(ConfigHelper.storageKeysSessions.imagensCardapio);
    imagensConcessionariaArray = JSON.parse(textImagensCardapio);
    
    var indexImagemConcessionaria =  imagensConcessionariaArray ? imagensConcessionariaArray.findIndex(item => item.codConcessionaria == this.concessionaria.codConcessionaria):-1;
    this.imagensConcessionaria = indexImagemConcessionaria!=-1? imagensConcessionariaArray[indexImagemConcessionaria]:null;
    
    // console.log("iniciaImagens", this.imagensConcessionaria);
    if(this.imagensConcessionaria!=null){
      this.iniciado = true;
    }
  }

  public buscaImagem(arteGrupo:string) {
    if(this.iniciado){
    var index = this.imagensConcessionaria? this.imagensConcessionaria.imagemGrupo.findIndex(item => item.arteGrupo == arteGrupo):null;
    if(index!=-1 && this.imagensConcessionaria.imagemGrupo[index].imagem!=""){
      return this.imagensConcessionaria.imagemGrupo[index].imagem;
    }else if(this.concessionaria.appBeta){
      return "assets/imgs/img_marca/"+this.concessionaria.logo_marca;
    }
      return "assets/imgs/carros/"+arteGrupo;
    }
  }


  public async  logout() {
    var image = await this.storage.get(ConfigHelper.storageKeysSessions.imagensCardapio);
    await this.storage.clear();
    await this.storage.set(ConfigHelper.storageKeysSessions.imagensCardapio, image);
    // await this.storage.forEach(async (v,key)=>{
    //   if(key!=ConfigHelper.storageKeysSessions.imagensCardapio){
    //     await this.storage.remove(key);
    //   }
    // });
  }

  async autenticar(model: any, codConcessionaria: any = "") : Promise<ConcessionariaModel> {
    try {
      let ResultConn = await this.httpSrv.post('auth/concessionaria/'+codConcessionaria,model);
      if (ResultConn.success)
      {
        //console.log(' CONCESSIONARIA MODEL AUTENTICAR ====> ', ResultConn.data)
        return <ConcessionariaModel>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao autenticar provider configuracao - concessionaria', error);
    }
  }

  async log(model: any, codConcessionaria: number) : Promise<any> {
    try {
      let ResultConn = await this.httpSrv.post('acampalog/'+codConcessionaria,model,0,0);
      if (ResultConn.success)
      {
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao autenticar provider configuracao - concessionaria', error);
    }
  }

  async updateAssinatura(model: any): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.put('updateassinatura/', model, 1, 1, 'Atualizando assinatura...',300000);
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }

  async listaconcessionarias() : Promise<Array<ConcessionariaModel>> {
    try {
      let ResultConn = await this.httpSrv.get('concessionarias');
      if (ResultConn.success)
      {
        return <Array<ConcessionariaModel>>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao autenticar provider configuracao - concessionaria', error);
    }
  }

  async salvarTermosUso(model: any) : Promise<boolean> {
    try {
      let ResultConn = await this.httpSrv.post('salvar_termos_uso',model);
      if (ResultConn.success)
      {
        return true
      }else {
        return false
      }
    } catch (error) 
    {
      console.log('Problema ao aceitar os termos de uso', error);
      return false
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/configuracao-concessionaria/configuracao-concessionaria.ts